import { CommonTag, TagType } from '../../../components/tag';
import getFormatMessage from '../../../locales/get-format-message';
import { SupportAccountRequestStatus } from '../../../model/api-modules';

const tagMap: Record<
  SupportAccountRequestStatus,
  { color: TagType; text: string }
> = {
  [SupportAccountRequestStatus.AwaitApproval]: {
    color: 'pink',
    text: getFormatMessage('待审批'),
  },

  [SupportAccountRequestStatus.Active]: {
    color: 'green',
    text: getFormatMessage('启用中'),
  },
  [SupportAccountRequestStatus.Expired]: {
    color: 'gray',
    text: getFormatMessage('已过期'),
  },
  [SupportAccountRequestStatus.Rejected]: {
    color: 'gray',
    text: getFormatMessage('已驳回'),
  },
};

export const renderStatusTag = (status: SupportAccountRequestStatus) => {
  const tagConfig = tagMap[status];
  if (tagConfig) {
    return <CommonTag type={tagConfig.color} text={tagConfig.text} />;
  }

  return null;
};

export const getSupportAccountStatusOptions = () =>
  Object.keys(tagMap).map((key) => {
    return {
      label: renderStatusTag(key as SupportAccountRequestStatus),
      value: key,
    };
  });

// 将Blob转换为文件下载
export function downloadLogs(
  recordData: Record<string, any>,
  fileName: string
) {
  const blob = new Blob([JSON.stringify(recordData, null, 2)], {
    type: 'application/json',
  });

  const myUrl = URL.createObjectURL(blob);
  if (!myUrl) return;
  const a = document.createElement('a');
  a.setAttribute('href', myUrl);
  if (fileName) a.setAttribute('download', fileName);
  a.setAttribute('target', '_blank');
  const clickEvent = document.createEvent('MouseEvents');
  clickEvent.initEvent('click', true, true);
  a.dispatchEvent(clickEvent);
  URL.revokeObjectURL(myUrl);
}
